// extracted by mini-css-extract-plugin
export default {"platforms":"Platforms_platforms__TeIRN"};